import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useMemo } from "react";
import CreditCardFieldset from "app/pages/Booking/Payment/CreditCardFieldset/CreditCardFieldset";
import { bindActionCreators } from "redux";
import { updateEncryptedCard } from "app/pages/Booking/Payment/paymentActionCreators";

const mapStateToProps = state => {
	const selectedPaymentType = state.booking.paymentType;
	const selectedPaymentMode = state.booking.paymentMode;
	const paymentTypes = state.payment.paymentTypes;

	const selectedPaymentTypeData = paymentTypes.find(paymentType => {
		return (
			paymentType.paymentType === selectedPaymentType &&
			paymentType.terms === selectedPaymentMode
		);
	});

	return {
		acceptedCreditCardTypes: selectedPaymentTypeData?.acceptedCreditCardTypes,
		adyenFlowPaymentSession: selectedPaymentTypeData?.paymentSession,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ updateEncryptedCard }, dispatch);
};

const CreditCardFieldsetContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	return <CreditCardFieldset {...props} {...stateProps} {...dispatchProps} />;
};

export default CreditCardFieldsetContainer;
